import type { PublicApiKey } from '#packages/apilib';
import type { createComponentPanelPreloaderApi } from './componentPanelPreloaderWrapper';

export const ComponentPanelPreloaderApiKey: PublicApiKey<
  typeof createComponentPanelPreloaderApi
> = {
  name: 'ComponentPanelPreloaderApi',
  public: true,
};
